module.exports = __webpack_public_path__ + "img/symbol_10.755a672a.png";